<template>
   <div
      v-if="visible"
      class="rounded-medium flex w-full items-start gap-3 px-[18px] py-4"
      :class="tinted ? ['border', tintClass] : ['bg-white', { __shadow: shadow }]"
   >
      <div class="pt-0.5">
         <Icon :name="statusProps.icon" class="size-6" :class="statusProps.colorClass" />
      </div>
      <div class="flex grow flex-col gap-1">
         <p class="h-m">
            {{ title }}
         </p>
         <p v-if="description" class="p-m" :class="title ? 'text-grey' : 'text-primary'">
            <span class="flex flex-col gap-1" v-if="Array.isArray(description)">
               <span v-for="d in description">
                  {{ d }}
               </span>
            </span>
            <span v-else>
               {{ description }}
            </span>
         </p>
      </div>
      <Icon
         v-if="inline"
         name="close"
         class="__clickable size-5 shrink-0"
         @click="visible = false"
      />
   </div>
</template>

<script lang="ts" setup>
import type { Status } from '@xleddyl/types'
import { computed, ref } from 'vue'

type Props = {
   title: string
   description?: string | string[]
   type?: Status
   inline?: boolean
   shadow?: boolean
   tinted?: boolean
}

const props = withDefaults(defineProps<Props>(), {
   inline: false,
   shadow: true,
   tinted: false,
})

const visible = ref<boolean>(true)

const statusProps = computed(() => getStatusProps(props.type))

const tintClass = computed(() => {
   switch (props.type) {
      case 'error':
         return 'border-red bg-red/5'
      case 'success':
         return 'border-green bg-green/20'
      case 'info':
         return 'border-grey bg-light-grey'
      case 'primary':
         return 'border-primary bg-primary/5'
      default:
         return 'border-yellow bg-yellow/10'
   }
})
</script>
